import React from "react";
import PaddingSettings from "fantastic/components/common/controls/padding/PaddingSettings";

export default ({ onChange, node }) => {
  const paddingParams = {
    onChange,
    node,
    bottom: "css_padding_bottom",
    left: "css_padding_left",
    lock: "css_padding_lock",
    right: "css_padding_right",
    top: "css_padding_top"
  };

  return <PaddingSettings {...paddingParams} />;
};
